import { type FC, type ReactNode } from "react";

import { Button } from "@snapchat/snap-design-system";

import { type MyLensesSubmissionError } from "../../../../gql-generated/types";
import { useLensSubmissionErrorsModalState } from "../../../hooks";
import { LensSubmissionErrorsModal } from "../../modal/LensSubmissionErrorsModal";

import { modalTriggerLinkButtonStyle } from "./LensSubmissionErrors.styles";
import { ModalTriggerText } from "./messages.generated";

interface LensSubmissionErrors {
    errorsLoading: boolean;
    submissionErrors: MyLensesSubmissionError[];
    children?: ReactNode;
}

export const LensSubmissionErrors: FC<LensSubmissionErrors> = ({
    submissionErrors,
    children,
    errorsLoading = false,
}) => {
    const [modalProps, showModal] = useLensSubmissionErrorsModalState();

    return (
        <>
            <Button
                data-testid="submission-errors-modal-trigger"
                onClick={showModal}
                type="link"
                className={modalTriggerLinkButtonStyle}
            >
                {children ?? <ModalTriggerText />}
            </Button>

            <LensSubmissionErrorsModal
                modalProps={modalProps}
                submissionErrors={submissionErrors}
                errorsLoading={errorsLoading}
            />
        </>
    );
};
